import { isResponseWithData } from 'lib-shared-auth';
import { ampli } from 'lib-shared-tracking';
import type { Tag } from 'lib-shared-types-api';
import { useContext, useEffect, useState } from 'react';

import { tagsApi } from 'apis/tags';
import { getCreateItemContext } from 'components/categorizedList';
import { TagContent } from 'components/tags/tagContent';

/** Represents the tag create item content. */
export const TagCreateItemContent = (): JSX.Element => {
  const { searchTerm: name, setCreate } = useContext(
    getCreateItemContext<Tag>(),
  );
  const [color, setColor] = useState<Tag['color']>(null);
  const [createTag] = tagsApi.useCreateTagMutation();

  // Handles setting the tag create function.
  useEffect(() => {
    setCreate(() => async () => {
      const response = await createTag({ name, color: color ?? undefined });
      if (isResponseWithData(response)) {
        ampli.tagSelectCreateNewTagClicked({
          tagName: name,
          component: 'CategorizedTagsList',
        });
        return response.data.data;
      }
    });
  }, [name, color, createTag, setCreate]);

  return <TagContent tag={{ name, color: null }} onColorChange={setColor} />;
};
